<template>
  <modal
    v-if="showModal"
    :size="size"
    @close="onCancel">
    <div
      slot="header"
      class="m-auto">
      <div class="alert-icon-wrapper m-auto">
        <i class="fas fa-exclamation-circle"/>
      </div>
    </div>
    <div slot="body">
      <p class="font-weight-normal"><slot/></p>
    </div>
    <div slot="footer">
      <ActionButton
        class-name="btn btn-lg btn-primary mr-2"
        @click="onCancel">{{ $t("CONFIRM_MODAL.BUTTON_CANCEL") }}</ActionButton>
      <ActionButton
        class-name="btn btn-lg btn-primary"
        @click="onConfirm">{{ $t("CONFIRM_MODAL.BUTTON_CONFIRM") }}</ActionButton>
    </div>
  </modal>
</template>

<script>
import Modal from './Modal';
import ActionButton from '@/components/Actions/ActionButton';

export default {
  name: 'ConfirmModal',
  components: {
    Modal,
    ActionButton,
  },
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fa-exclamation-circle {
  color: $secondary;
  font-size: 80px;
}

p:last-child {
  margin-bottom: 0;
}
</style>
